import React from "react"
import Link from "./Link"
import makeStyles from "@material-ui/core/styles/makeStyles"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import Button from "@material-ui/core/Button"
import CloseIcon from "@material-ui/icons/Close"

const useStyles = makeStyles(theme => ({
  List: {
    display: "flex",
    flexDirection: props => props.dropdown && "column",
    justifyContent: props => (props.dropdown ? "center" : "space-between"),
    alignItems: props => props.dropdown && "center",
    flexGrow: 1,
    width: props => props.dropdown && "70vw",
    height: props => props.dropdown && "100vh",
  },
  ListItem: {
    position: "relative",
    width: "auto",
    [theme.breakpoints.down("xs")]: {
      width: "90%",
    },
    [theme.breakpoints.between("md", "sm")]: {
      width: props => (props.dropdown ? "60%" : "auto"),
    },
    textAlign: props => props.dropdown && "center",
    "& a": {
      textAlign: props => props.dropdown && "center",
      width: "100%",
    },
    "& a:hover, & a:focus, & a:focus-within, & a:active": {
      textDecoration: "none",

      "&:before": {
        position: "absolute",
        left: props => (props.dropdown ? "2%" : "-2%"),
        top: "50%",
        bottom: "50%",
        margin: "auto",
        content: `''`,
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        background: "purple",
      },
      [theme.breakpoints.down("sm")]: {
        "&:after": {
          position: "absolute",
          right: "2%",
          top: "50%",
          bottom: "50%",
          margin: "auto",
          content: `''`,
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          background: "purple",
        },
      },
    },
  },
  ListItemText: {
    "& span": {
      fontFamily: "inherit !important",
    },
  },
}))

const Nav = ({ dropdown, toggleDrawer }) => {
  const classes = useStyles({ dropdown })
  return (
    <List className={classes.List}>
      {dropdown && (
        <Button onClick={toggleDrawer}>
          <CloseIcon />
        </Button>
      )}
      <ListItem className={classes.ListItem}>
        <Link to="/">
          <ListItemText className={classes.ListItemText} primary="HOME" />
        </Link>
      </ListItem>
      <ListItem className={classes.ListItem}>
        <Link to="/#about">
          <ListItemText className={classes.ListItemText} primary="WHAT WE DO" />
        </Link>
      </ListItem>
      <ListItem className={classes.ListItem}>
        <Link to="/#testimonials">
          <ListItemText
            className={classes.ListItemText}
            primary="TESTIMONIALS"
          />
        </Link>
      </ListItem>
      <ListItem className={classes.ListItem}>
        <Link to="/#gallery">
          <ListItemText className={classes.ListItemText} primary="GALLERY" />
        </Link>
      </ListItem>
      <ListItem className={classes.ListItem}>
        <Link to="/kitchen">
          <ListItemText
            className={classes.ListItemText}
            primary="GLOONE KITCHEN"
          />
        </Link>
      </ListItem>
      <ListItem className={classes.ListItem}>
        <Link to="/#contact-form">
          <ListItemText className={classes.ListItemText} primary="CONTACT US" />
        </Link>
      </ListItem>
    </List>
  )
}

export default Nav
